import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDate(date: Date): string {
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}

export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}

export function slugify(text: string): string {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(/[^\w\-]+/g, "") // Remove all non-word chars
    .replace(/\-\-+/g, "-") // Replace multiple - with single -
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
}

export function getRandomItem<T>(array: T[]): T {
  return array[Math.floor(Math.random() * array.length)];
}

export function getTagColor(tag: string): { bg: string; text: string } {
  const tagMap: Record<string, { bg: string; text: string }> = {
    "History": { bg: "bg-[#30D5C8] bg-opacity-10", text: "text-[#30D5C8]" },
    "Food": { bg: "bg-[#E30A17] bg-opacity-10", text: "text-[#E30A17]" },
    "Nature": { bg: "bg-[#30D5C8] bg-opacity-10", text: "text-[#30D5C8]" },
    "Adventure": { bg: "bg-[#E30A17] bg-opacity-10", text: "text-[#E30A17]" },
    "Beach": { bg: "bg-[#30D5C8] bg-opacity-10", text: "text-[#30D5C8]" },
    "Ruins": { bg: "bg-[#E30A17] bg-opacity-10", text: "text-[#E30A17]" },
    "Architecture": { bg: "bg-[#30D5C8] bg-opacity-10", text: "text-[#30D5C8]" },
    "Culture": { bg: "bg-[#E30A17] bg-opacity-10", text: "text-[#E30A17]" },
  };
  
  return tagMap[tag] || { bg: "bg-gray-200", text: "text-gray-700" };
}
